import { h2, h3, detailsBigCss } from "@/styles/typography";
import styled from "styled-components";

const BlogWrapper = styled.div`
  width: 100%;

  .active-link {
    border-bottom: 5px solid ${({ theme }) => theme.colors.primary};
  }
`;

const Container = styled.div`
  height: 100%;
  width: 100%;
  margin-bottom: 70px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(420px, 100%), 1fr));
  grid-gap: 27px;
  transition: all 0.3s ease-in-out;
  
  @media screen and (max-width: 1250px) {
    grid-template-columns: 1fr;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: baseline;

  @media screen and (max-width: 1050px) {
    display: block;
  }
`;

const LinkWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 75%;
  padding-left: 15%;

  @media screen and (max-width: 1050px) {
    padding: 0;
    width: 100%;
    overflow: scroll;
    margin-bottom: 30px;
  }
`;

const Button = styled.button`
  ${detailsBigCss}
  border: none;
  background-color: transparent;
  margin: 0 25px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  list-style: none;
  transition: all 0.3s;

  &:hover {
    border-bottom: 5px solid ${({ theme }) => theme.colors.primary};
  }

  &:first-of-type {
    margin: 0 25px 0 0;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin: 0 16px;
    margin-bottom: 15px;
  }
`;

const Title = styled(h2)`
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 50px;
  text-transform: uppercase;
  width: fit-content;

  @media ${({ theme }) => theme.breakpoints.md} {
    margin-bottom: 32px;
  }
`;

const H3 = styled(h3)`
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 50px;
  text-transform: uppercase;
  width: fit-content;

  @media ${({ theme }) => theme.breakpoints.md} {
    margin-bottom: 32px;
  }
`;

const Line = styled.div`
  margin-top: 30px;
  width: 100%;
  height: 2px;
  background-color: ${({ theme }) => theme.colors.primary};
`;

const S = {
  BlogWrapper,
  Container,
  TitleWrapper,
  LinkWrapper,
  Button,
  Title,
  H3,
  Line,
};

export default S;
